<template>
    <div>
        <v-container>
            <v-card-actions>
                <router-link to="/resources">
                    <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
                </router-link>
            </v-card-actions>
            <h1>{{ card.title }}</h1>
            <!-- Título y subtítulo 
            
            <h3>{{ card.subtitle }}</h3>-->
            <v-divider></v-divider>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <v-img class="align-end text-white" contain :style="{ 'max-width': '180vh', 'max-height': '50vh' }" :src="getImageSrc(card.images)"></v-img>
                </v-col>                               
            </v-row>
            <v-row>                
                <v-col cols="12" md="12">
                    <p style="font-size: 50px; color: rgb(15, 135, 201);"><b>________________________________________________</b></p>
                    <!---->
                    
                    <details @click="mostrarAdjuntosCategories(2)" open>
                        <summary id="cat17">
                            <p><b>Elearning</b></p>
                        </summary>
                        <div class="pad-text">
                            <p>
                                The <a href="https://elearningunodc.org/?lang=en" target="_blank"><b>UNODC Learning and Innovation Programme</b></a> offers foundational and advanced digital training on Crime Prevention and Criminal Justice through its eLearning platform, 
                                <a href="https://elearningunodc.org/?lang=en" target="_blank">SPARK</a>. Please access it <a href="https://elearningunodc.org/?lang=en" target="_blank">here</a>.
                            </p>
                            <p>
                                Designed for <b>criminal justice pr ofessionals</b>, SPARK provides a wide range of <b>self-paced eLearning modules</b> and interactive digital tools. Courses are available in English, French, Portuguese, Spanish, and other languages, ensuring accessibility for a global audience.
                            </p>
                            <p>
                                Accessible <b>24/7 via web browser and mobile app</b>, SPARK has reached over <b>250,000 users worldwide</b>, supporting capacity-building efforts across regions.
                            </p>
                            <p>
                                The digital training portfolio includes, inter alia, key topics such as:
                            </p>
                            <ul>
                                <li>Gender-responsive non-custodial measures</li>
                                <li>International classification of crimes for statistical purposes</li>
                                <li>Good practices in police capacity-building</li>
                                <li>Law enforcement officials and their role in upholding human rights</li>
                                <li>Crime scene investigation</li>
                                <li>Maritime crime</li>
                                <li>Access to legal aid for women in criminal justice systems</li>
                                <li>Implementation of the Kyoto Declaration</li>
                                <li>Judicial ethics and conduct</li>
                            </ul>
                            <p>SPARK is a vital tool in strengthening knowledge, promoting best practices, and advancing justice systems that are fair, effective, and rights-based.</p>
                        </div>
                    </details>


                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios';

// Componente recursivo para items de la tabla de contenido
const TocItem = {
  name: 'TocItem',
  props: {
    item: { type: Object, required: true }
  },
  data() {
    return { isExpanded: false };
  },
  computed: {
    hasChildren() {
      return this.item && Array.isArray(this.item.children) && this.item.children.length > 0;
    }
  },
  methods: {
    toggle() {
      if (this.hasChildren) {
        this.isExpanded = !this.isExpanded;
        this.$emit('toggle', this.item.id);
      }
    }
  },
  render(h) {
  const toggleSpan = this.hasChildren
    ? h('span',
        { style: { marginRight: '8px', fontWeight: 'bold', minWidth: '20px' } },
        this.isExpanded ? '▼' : '▶'
      )
    : null;

  // aquí creamos el bullet sólo para los items sin children
  const bulletSpan = !this.hasChildren
    ? h('span',
        { class: 'leaf-bullet', style: { marginRight: '8px', fontWeight: 'normal' } },
        '▪'
      )
    : null;

  const link = h(
    'a',
    {
      attrs: { href: this.item.href },
      style: { textDecoration: 'none', color: 'inherit' },
      on: { click: e => e.stopPropagation() }
    },
    this.item.title
  );

  // en lugar de discriminar en dos arrays, usamos toggleSpan o bulletSpan
  const header = h(
    'div',
    {
      style: { display: 'flex', alignItems: 'center', cursor: this.hasChildren ? 'pointer' : 'default' },
      on: { click: this.toggle }
    },
    [ toggleSpan || bulletSpan, link ]
  );

  const childrenList = (this.hasChildren && this.isExpanded)
    ? h('ul', { style: { listStyle: 'none', paddingLeft: '20px', marginTop: '5px' } },
        this.item.children.map((child, idx) =>
          h(this.$options, { props: { item: child }, key: idx })
        )
      )
    : null;

  return h('li', { class: 'toc-item', style: { marginBottom: '5px' } }, [header, childrenList]);
}
};

export default {
  components: {
    TocItem
  },
  data() {
    return {            
      nombresAdjuntos: [], nombresAdjuntos2: [], nombresAdjuntos3: [], nombresAdjuntos4: [], nombresAdjuntos5: [], nombresAdjuntos6: [], nombresAdjuntos7: [],
      nombresAdjuntos8: [],
      // Estructura de datos para la tabla de contenido
      tocItems: [
        { id: 1, title: '1. Crime Prevention and Criminal Justice: definitions and linkages with SDGs and the 2030 Agenda', href: '#cat1' },
        { id: 2, title: '2. International and Regional standards', href: '#cat2' },
        { id: 3, title: '3. The United Nations Commission on Crime Prevention and Criminal Justice (CCPCJ)', href: '#cat3' },
        { id: 4, title: '4. The United Nations Congresses on Crime Prevention and Criminal Justice', href: '#cat4' },
        { 
          id: 5, 
          title: '5. Crime Prevention', 
          href: '#cat5',
          children: [
            { id: 51, title: '5.1 The challenges', href: '#cat5_1' },
            { id: 52, title: '5.2. Social and economic costs associated with crime and violence', href: '#cat5_2' },
            { id: 53, title: '5.3. Targeting risks and protective factors', href: '#cat5_3' }
          ]
        },
        { 
          id: 6, 
          title: '6. Youth', 
          href: '#cat6',
          children: [
            { id: 61, title: '6.1. Prevention and strengthening youth resilience to crime', href: '#cat6_1' },
            { id: 62, title: '6.2. Prevention and response frameworks', href: '#cat6_2' },
            { id: 63, title: '6.3. UN programmatic services', href: '#cat6_3' },
            { id: 64, title: '6.4. Tools and resources', href: '#cat6_4' }
          ]
        },
        { 
          id: 7, 
          title: '7. Sport', 
          href: '#cat7',
          children: [
            { id: 71, title: '7.1. Sport for development and crime prevention', href: '#cat7_1' },
            { id: 72, title: '7.2. Respect, equality and fair play', href: '#cat7_2' },
            { id: 73, title: '7.3. Empowering young people and local communities', href: '#cat7_3' },
            { id: 74, title: '7.4. UN programmatic services', href: '#cat7_4' },
            { id: 75, title: '7.5. Tools and resources', href: '#cat7_5' }
          ]
        },
        { 
          id: 8, 
          title: '8. Communities', 
          href: '#cat8',
          children: [
            { id: 81, title: '8.1. UN programmatic services', href: '#cat8_1' },
            { id: 82, title: '8.2. Tools and resources', href: '#cat8_2' },
            { id: 83, title: '8.3. Online tools and databases', href: '#cat8_3' }
          ]
        },
        { 
          id: 9, 
          title: '9. Professionalization of policing', 
          href: '#cat9',
          children: [
            { id: 91, title: '9.1. International standards', href: '#cat9_1' },
            { id: 92, title: '9.2. UN programmatic services', href: '#cat9_2' },
            { id: 93, title: '9.3. Tools and resources', href: '#cat9_3' }
          ]
        },
        { 
          id: 10, 
          title: '10. Equal justice for all', 
          href: '#cat10',
          children: [
            { id: 101, title: '10.1. UN programmatic services', href: '#cat10_1' }
          ]
        },
        { 
          id: 11, 
          title: '11. Access to legal aid', 
          href: '#cat11',
          children: [
            { id: 111, title: '11.1. International standards', href: '#cat11_1' },
            { id: 112, title: '11.2. UN programmatic services', href: '#cat11_2' },
            { id: 113, title: '11.3. Tools and resources', href: '#cat11_3' },
            { id: 114, title: '11.4. Surveys and data', href: '#cat11_4' }
          ]
        },
        { 
          id: 12, 
          title: '12. Prosecution, courts and the judiciary', 
          href: '#cat12',
          children: [
            { id: 121, title: '12.1. International standards', href: '#cat12_1' },
            { id: 122, title: '12.2. UN programmatic services', href: '#cat12_2' },
            { id: 123, title: '12.3. Tools and resources', href: '#cat12_3' }
          ]
        },
        { 
          id: 13, 
          title: '13. Victim support, assistance and protection', 
          href: '#cat13',
          children: [
            { id: 131, title: '13.1. International standards', href: '#cat13_1' },
            { id: 132, title: '13.2. UN programmatic services', href: '#cat13_2' },
            { id: 133, title: '13.3. Tools and resources', href: '#cat13_3' }
          ]
        },
        { 
          id: 14, 
          title: '14. Gender in the Criminal Justice System', 
          href: '#cat14',
          children: [
            { id: 141, title: '14.1. International standards', href: '#cat14_1' },
            { id: 142, title: '14.2. UN programmatic services', href: '#cat14_2' },
            { id: 143, title: '14.3. Tools and resources', href: '#cat14_3' }
          ]
        },
        { 
          id: 15, 
          title: '15. Justice for, and with, children', 
          href: '#cat15',
          children: [
            { id: 151, title: '15.1. International standards', href: '#cat15_1' },
            { id: 152, title: '15.2. Child victims and witnesses of crime and violence', href: '#cat15_2' },
            { id: 153, title: '15.3. Children alleged as, accused of or recognised as having infringed criminal/penal law', href: '#cat15_3' },
            { id: 154, title: '15.4. UN programmatic services', href: '#cat15_4' },
            { id: 155, title: '15.5. Tools and resources', href: '#cat15_5' }
          ]
        },
        { 
          id: 16, 
          title: '16. Restorative Justice', 
          href: '#cat16',
          children: [
            { id: 161, title: '16.1. International standards', href: '#cat16_1' },
            { id: 162, title: '16.2. UN programmatic services', href: '#cat16_2' },
            { id: 163, title: '16.3. Tools and resources', href: '#cat16_3' }
          ]
        },
        { id: 17, title: '17. ELearning', href: '#cat17' }
      ],
      card: {
        id: 0,
        title: '',
        subtitle: '',
        description: '',
        additionalInfo: '',
        additionalInfo2: '',
        images: [],
        chip: [],
      },
      cards: [
        {
          id: 3,
          title: 'CRIME PREVENTION AND CRIMINAL JUSTICE',
          subtitle: 'UNODC',
          // Ya no necesitamos category como HTML string
          additionalInfo: 'Additional Info',
          additionalInfo2: 'UNODC develops tools for stakeholders to assist States in the implementation of the UN standards and norms. They include a variety of handbooks, training curriculums and model laws which provide guidance to United Nations agencies, governments and individuals at each stage of criminal justice reform'+
                          'An overview of all the handbooks and manuals that the Justice Section develops is available in English, French, Spanish,Russian',
          description: '',                    
          images: ['3.jpg'],                    
          chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
          link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
        },
      ],
    };  
  },
  methods: {
    toggleItem(itemId) {
      // Podemos agregar lógica adicional aquí si es necesario
      console.log('Toggled item:', itemId);
    },
    descargarArchivo(nombreArchivo) {
      const url = `https://unlabccback.rocol.org/api/Categories/MostrarCrimePrevention/${nombreArchivo}`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    descargarCategory(id, nombreArchivo) {
      const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte2/${id}/${nombreArchivo}`;
      const extension = nombreArchivo.split('.').pop().toLowerCase();
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (xhr.status === 200) {
          const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });
          if (extension === 'pdf') {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = nombreArchivo;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      };
      xhr.send();
    },
    async mostrarAdjuntosCategories(id) {
      try {
        const response = await axios.get(`api/Categories/MostrarCategoriesCrimePrevention/${id}`);
        switch (id) {
          case 1:
            this.nombresAdjuntos = response.data;
            break;
          case 2:
            this.nombresAdjuntos2 = response.data;
            break;
          case 3:
            this.nombresAdjuntos3 = response.data;
            break;
          case 4:
            this.nombresAdjuntos4 = response.data;
            break;
          case 5:
            this.nombresAdjuntos5 = response.data;
            break;
          case 6:
            this.nombresAdjuntos6 = response.data;
            break;
          case 7:
            this.nombresAdjuntos7 = response.data;
            break;
          case 8:
            this.nombresAdjuntos8 = response.data;
            break;
          default:
            console.error("ID no válido:", id);
            break;
        }
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    getImageSrc(filename) {
      return require(`../../assets/${filename}`);
    },
  },
  created() {
    const cardId = parseInt(this.$route.params.id);
    this.card = this.cards.find(card => card.id === cardId);
  },
};
</script>

<style>
  p {
    font-family: 'Heebo', sans-serif;
    font-size: 16px;        
    line-height: 1.6em;
  }
  h1 {
    font-family: 'Heebo', sans-serif;
  }
  h2 {
    font-family: 'Heebo', sans-serif;
  }
  h3 {
    font-family: 'Heebo', sans-serif;
  }
  
  /* Estilos para la tabla de contenido */
  .toc-item {
    margin-bottom: 8px;
  }
  
  .toc-toggle {
    cursor: pointer;
    margin-right: 8px;
    font-weight: bold;
    min-width: 20px;
    display: inline-block;
    text-align: center;
  }
  
  .toc-link {
    text-decoration: none;
    color: inherit;
  }
  
  .toc-link:hover {
    color: #1976d2;
  }
  
  .toc-children {
    list-style: none;
    padding-left: 20px;
    margin-top: 5px;
  }
  
  .document-columns {
    columns: 2;
    column-gap: 20px;
  }

  .leaf-bullet {
  display: inline-block;
  width: 0.9rem;          /* mismo ancho que .arrow para alinear texto */
  text-align: center;
  color: var(--bs-link-color, #0d6efd); 
  font-size: 1.2rem;   
  line-height: 1;
  vertical-align: middle;
  position: relative;
  top: 2px;               /* mismo ajuste que la flecha */
}
.toc-item,
  .toc-item a,
  .toc-item span {
    color: #0d6efd !important;
  }

</style>